import styled, { css } from 'styled-components';
import Button from '../../../_shared/components/Button';
import { Title, StyledButton } from '../VehicleDetails/Styles';
import isOmpPlatform from '../../../_shared/utils/isOmpPlatform';

const isOmp = isOmpPlatform();

export const Section = styled.section`
  padding: 18px 0 32px 0;
  border-bottom: 1px solid
    ${({ theme }) =>
      isOmp ? theme.COLORS.NEUTRAL_110 : theme.COLORS.NEUTRAL_50};

  &:first-child {
    padding-top: 0;
  }

  &:last-child {
    border-bottom: none;
    padding-bottom: 0;
  }
`;

export const SideRailContainer = styled.aside`
  position: sticky;
  grid-area: siderail;
  top: ${props => props.top || 0}px;
  padding: 24px;
  ${({ theme }) =>
    isOmp
      ? css`
          border: 1px solid ${theme.COLORS.NEUTRAL_110};
          border-radius: 3px;
        `
      : css`
          box-shadow: 0 1px 6px rgba(0, 0, 0, 0.2);
        `}

  height: max-content;
  max-width: 371px;

  @media only screen and (max-width: ${({ theme }) => theme.BP.VDP_MOBILE_WH}) {
    max-width: 520px;
    padding: 20px;
    margin: 0;
    box-shadow: none;
    position: static;
    border-bottom: 1px solid
      ${({ theme }) =>
        isOmp ? theme.COLORS.NEUTRAL_110 : theme.COLORS.NEUTRAL_30};
    grid-column-start: auto;
    grid-row: auto;
  }
`;

export const PriceContainer = styled.div`
  font-size: ${({ theme }) => theme.FONT_SIZES.SMALL};
  color: ${({ theme }) => theme.COLORS.NEUTRAL_30};
  display: flex;
  flex-direction: column;
`;

export const Price = styled.span`
  font-size: ${({ theme }) => theme.FONT_SIZES.XXLARGE};
  font-family: ${({ theme }) => theme.FONT.SEMI_BOLD};
  color: ${({ theme }) => theme.COLORS.BASE_INVERTED};
`;

export const DealershipName = styled.p`
  margin: 18px 0 0 0;
  font-size: ${({ theme }) => theme.FONT_SIZES.XXLARGE};
  word-wrap: break-word;
`;

export const AddressContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const AddressLine = styled.span``;

export const DirectionsLink = styled.a`
  && {
    text-decoration: ${isOmp ? 'none' : 'underline'};
  }
  margin: 6px 0 30px;
`;

export const Salesperson = styled.p`
  && {
    margin: 16px 0;
  }
`;

export const PhoneNumber = styled.p`
  svg {
    margin-right: 18px;
    width: 18px;
    height: 18px;
  }
  && {
    margin: 16px 0;
  }
`;

export const Email = styled.a`
  text-decoration: ${isOmp ? 'none' : 'underline'};

  svg {
    margin-right: 18px;
    width: 18px;
    height: 18px;
  }
`;

export const SeeMore = styled.div`
  margin-top: 27px;
`;

export const StyledInventoryButton = styled(StyledButton)`
  margin-top: 8px;
  text-transform: none;
`;

export const TiahLogo = styled.img``;

export const StyledTitle = styled(Title)`
  && {
    margin: 18px 0 12px 0;
  }
`;

export const TiahText = styled.p`
  margin: 0;
`;

export const TiahDealership = styled.span`
  font-family: ${({ theme }) => theme.FONT.SEMI_BOLD};
`;

export const StyledTiahButton = styled(Button.Primary)`
  text-transform: initial;
  padding: 15px;
  width: 100%;
  font-size: ${({ theme }) => theme.FONT_SIZES.MEDIUM};
  margin: 24px 0;
`;

export const StyledLogo = styled.img`
  display: block;
  width: 192px;
  height: 100px;
  margin: 10px 0;
  object-fit: contain;
`;
